import { MDBBadge, MDBInput, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import api from '../../app/api/agent'
import { GlobalStateContext } from '../../store/GlobalState';
import CustomNavBar from '../../components/CustomNavBar';
import React from 'react';
import { alpha, Box, Button, createTheme, Dialog, Stack, Typography } from '@mui/material';
import formatDate from '../../utils/formatDate';
import SimpleDialogSuccess from '../../components/DialogSuccess';
//import Cookies from 'js-cookie';

function FormList() {

    const [pageRecord, setPageRecord] = useState<Array<{ [x: string]: any }>[] | undefined>(undefined)
    const [recordList, setRecord] = useState<Array<{ [x: string]: any }>| undefined>(undefined)
    const [versionList, setVersion] = useState<Array<{ [x: string]: any }>| undefined>(undefined)
    const [Open, setOpen] = useState(false)
    const [openSuccessDelete, setOpenSuccessDelete] = useState(false)
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    const [formId, setformId] = useState("")
    const [contractNum, setContractNum] = useState("")
    const [customerRef, setCustomerRef] = useState("")
    const [customer, setCustomer] = useState("")
    const [project, setProject] = useState("")
    const [pageNum, setPageNum] = useState(1)
    const [sortOrder, setsortOrder] = useState(false)
    const [sortedBy, setsortedBy] = useState("DisplayId")
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageSize, setPageSize] = useState(10)
    const [isDownload, setIsDownload] = useState(false)
    const [TotalRecord, setTotalRecord] = useState(0)

    const [tempDeleteId, setTempDeleteId] = useState("")

    const openRecordTab=(id: string)=>{
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newWindow = window.open(`/form/view?formId=${id}`, '_blank', 'noopener,noreferrer')
    }
    const editRecordTab=(id: string, status: string)=>{
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newWindow = window.open(`/form/edit?formId=${id}&status=${status}`, '_blank', 'noopener,noreferrer')
    }
    const cloneRecordTab=(id: string)=>{
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newWindow = window.open(`/form?formId=${id}`, '_blank', 'noopener,noreferrer')
    }

    const theme = createTheme({
            palette: {
                primary: {
                    main: '#2e7d32',
                  },
            },
          });

    const handleClose = () => {
      setOpen(false);
    };

    const handleCloseSuccessDelete = () => {
      setOpenSuccessDelete(false);
      window.location.reload();
    }

    const handleDeleteSavedForm=(id: string)=>{
      api.delete(`/SteelBarForm/save?formId=${id}`,{withCredentials: true}).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      setOpenConfirmDelete(false)
                      setOpenSuccessDelete(true)
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
    }

    const downloadList=(id: string)=>{
        api.get(`/Report/SteelBarForm/PdfVersionList/${id}`,{withCredentials: true}).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      setVersion(response.data)
                      setOpen(true)
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
    }
    const downloadRecord=(id: string)=>{
        api.get(`/Report/SteelBarForm/${id}`,{withCredentials: true, responseType: 'blob'}).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', `${id}.pdf`);
                      document.body.appendChild(link);
                      link.click()
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
    }
    const downloadPdfVersion=(id: string, downloadURL: string)=>{
        api.get(downloadURL,{withCredentials: true, responseType: 'blob'}).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', `${id}.pdf`);
                      document.body.appendChild(link);
                      link.click()
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
    }
    const globalState = useContext(GlobalStateContext);
    useEffect(()=>{
        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      if(localStorage.getItem("role") === "0"){
                        getRecord();
                      }else{
                        getRecordUser();
                      }
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                            window.location.href='/'
                    }else{
                      if(localStorage.getItem("role") === "0"){
                        getRecord();
                      }else{
                        getRecordUser();
                      }
                    }
                    }).catch(()=>{
                        window.location.href='/'
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[sortOrder, sortedBy, pageNum])

    useEffect(()=>{
        setPageNum(pageNum)
    },[pageNum])


    const getFilterAndValueList = ()=>{
      var listFilter = []
      var listValue = []
      if(formId !== ""){
        listFilter.push("DisplayId")
        listValue.push(formId)
      }
      if(contractNum !== ""){
        listFilter.push("ContractNum")
        listValue.push(contractNum)
      }
      if(customerRef !== ""){
        listFilter.push("CustomerRef")
        listValue.push(customerRef)
      }
      if(customer !== ""){
        listFilter.push("Customer")
        listValue.push(customer)
      }
      if(project !== ""){
        listFilter.push("Project")
        listValue.push(project)
      }
      return [listFilter, listValue]
    }

    const getRecordUser=async ()=>{
        const [listFilter, listValue]= getFilterAndValueList();
        //await api.get(`/SteelBarForm/list/user?sortMethod=${sortedBy}&isASC=${sortOrder}`,{withCredentials: true,}).then((response)=>{
        await api.post(`/SteelBarForm/list/user`,{sortMethod: sortedBy, isASC: sortOrder, filterBy: listFilter, value: listValue, pageNo: pageNum, pageSize: pageSize},{withCredentials: true,}).then((response)=>{
              setRecord(response.data["items"])
              pageSeperate(response.data["items"])
              setTotalRecord(response.data["totalCount"])
        })
    }

    const getRecord=async ()=>{
        const [listFilter, listValue]= getFilterAndValueList();
        //await api.get(`/SteelBarForm/list?sortMethod=${sortedBy}&isASC=${sortOrder}`,{withCredentials: true,}).then((response)=>{
        await api.post(`/SteelBarForm/list`,{sortMethod: sortedBy, isASC: sortOrder, filterBy: listFilter, value: listValue, pageNo: pageNum, pageSize: pageSize},{withCredentials: true,}).then((response)=>{
              setRecord(response.data["items"])
              pageSeperate(response.data["items"])
              setTotalRecord(response.data["totalCount"])
              setIsDownload(true)
        })
    }
    const pageSeperate = (records: Array<{ [x: string]: any }>) =>{
        var i = 0;
        var tempList: Array<{ [x: string]: any }>[] = []
        records?.forEach((record, index)=>{
            if(tempList[i] === undefined){tempList[i]=[]}
            tempList[i].push(record)
            if((index+1)%10 ===0){i+=1}
        })
        setPageRecord(tempList)
    }

    /* useEffect(()=>{
         if(localStorage.accessToken){
          getRecordUser();
        }else{
          getRecord();
        } 
       if(pageRecord != null)
       setRecord(pageRecord[pageNum - 1])
    },[pageNum, pageRecord]) */


    const setSortByAndSortOrder= (SortBy: string)=>{
        /* if(sortedBy !== SortBy){
          setsortedBy(SortBy)
          setsortOrder("Desc")
        }else{
          if(sortOrder === "Desc"){
            setsortOrder("Asc")
          }else{
            setsortOrder("Desc")
          }
        } */
        if(sortedBy !== SortBy){
          setsortedBy(SortBy)
          setsortOrder(false)
          setPageNum(1)
        }else{
          if(sortOrder === false){
            setsortOrder(true)
            setPageNum(1)
          }else{
            setsortOrder(false)
            setPageNum(1)
          }
        }
    }

    const handleSearch= async()=>{
        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      if(localStorage.getItem("role") === "0"){
                        getRecord();
                      }else{
                        getRecordUser();
                      }
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                            window.location.href='/'
                    }else{
                      if(localStorage.getItem("role") === "0"){
                        getRecord();
                      }else{
                        getRecordUser();
                      }
                    }
                    }).catch(()=>{
                        window.location.href='/'
                })
        }
    }

  const handlePageChange = (event: { target: { value: any; }; }) => {
    const inputValue = event.target.value;

    // 1. Allow only numeric input and optional decimal point
    const numericValue = inputValue.replace(/[^0-9.]/g, ''); 

    // 2. Convert to a number for range validation
    const numValue = parseFloat(numericValue);

    // 3. Validate against the range and update state if valid
    if (!isNaN(numValue) && numValue >= 1 && numValue <= Math.ceil(TotalRecord/pageSize)) {
      setPageNum(numValue); // Keep as string to handle partial inputs like "1."
    } else if (numericValue === '') { // Allow clearing the input
      setPageNum(1);
    }
    // Optionally, you could provide feedback to the user if the value is out of range
  };

  return (
    <Container className="table-responsive" style={{minWidth: "770px", padding: 0, fontFamily:"Poppins", width:"95%", height:"100vh", background:"linear-gradient(45deg,rgba(255, 255, 255, 1) 0%, rgba(245, 255, 247, 1) 50%, rgba(222, 255, 232, 1) 100%)"}}>
    <CustomNavBar></CustomNavBar>
    <div className='search-fields-wrapper'>
      <MDBInput onChange={(e) => setformId(e.target.value)} label="Form Id 表格編號" id="formId" type="text" />
      <MDBInput onChange={(e) => setContractNum(e.target.value)} label="Contract No. 合約編號" id="contractNum" type="text" />
      <MDBInput onChange={(e) => setCustomerRef(e.target.value)} label="Customer Ref. No. 客戶參考編號" id="customerRef" type="text" />
      <MDBInput onChange={(e) => setCustomer(e.target.value)} label="Customer 客戶名稱" id="customer" type="text" />
      <MDBInput onChange={(e) => setProject(e.target.value)} label="Project 項目名稱" id="project" type="text" />
      <span onClick={()=>{handleSearch()}} style={{cursor:"pointer", color:"blue", fontSize:"15px", marginLeft:"auto"}}>
          <MDBBadge className='badge' color='success' pill style={{fontSize:"18px"}}>
            Search
          </MDBBadge>
      </span>
    </div>
    {/* <Table striped bordered hover responsive size='sm'> */}
    <MDBTable align='middle' className="table table-hover table-custom" style={{width:"95%", margin:"auto", minWidth: "770px !important"}}>
      {/* <thead style={{borderBottom:"12px"}}> */}
      <MDBTableHead>
        <tr className='table-success' key="mdbtableheader">
          <th onClick={()=>{setSortByAndSortOrder("DisplayId")}} style={{cursor:"pointer"}} className='hoverth tableword-wrap'>Form Id <br></br>表格編號</th>
          <th onClick={()=>{setSortByAndSortOrder("ContractNum")}} style={{cursor:"pointer"}} className='hoverth tableword-wrap'>Contract No. <br></br>合約編號</th>
          <th onClick={()=>{setSortByAndSortOrder("CustomerRef")}} style={{cursor:"pointer"}} className='hoverth tableword-wrap'>Customer Ref. No. <br></br>客戶參考編號</th>
          <th onClick={()=>{setSortByAndSortOrder("Customer")}} style={{cursor:"pointer"}} className='hoverth tableword-wrap'>Customer <br></br>客戶名稱</th>
          <th onClick={()=>{setSortByAndSortOrder("Project")}} style={{cursor:"pointer"}} className='hoverth tableword-wrap'>Project <br></br>項目名稱</th>
          <th onClick={()=>{setSortByAndSortOrder("CreateTime")}} style={{cursor:"pointer"}} className='hoverth tableword-wrap'>Submit Date <br></br>提交日期</th>
          <th>Status <br></br>狀況</th>
          <th className='tableword-wrap'>View / Edit / Delete<br></br>查看 / 編輯 / 刪除</th>
          <th className='tableword-wrap'>Clone <br></br>複製</th>
          {(localStorage.getItem("role") === "0" ) && isDownload === true &&
          <th className='tableword-wrap'>Download <br></br>下載</th>}
          {(localStorage.getItem("role") === "0") &&
          <th className='tableword-wrap'>Versions <br></br>版本</th>}
        </tr>
      {/* </thead> */}
      </MDBTableHead>
      <MDBTableBody>
      {/* <tbody> */}
      {recordList === undefined || recordList === null ? <></>: recordList.map((record, recordIndex)=>{
            return<React.Fragment key={record["id"]}>
                <tr className={recordIndex % 2 === 1 ? 'table-success' : 'bg-white'} key={`mdbtablerow${recordIndex * pageNum}`}>
                <td className='tableword-wrap'>{record["displayId"].toString()}</td>
                <td className='tableword-wrap'>{record["contractNum"] ? record["contractNum"].toString() : ""}</td>
                <td className='tableword-wrap'>{record["customerRef"] ? record["customerRef"].toString() : ""}</td>
                <td className='tableword-wrap'>{record["customer"] ? record["customer"].toString() : ""}</td>
                <td className='tableword-wrap'>{record["project"] ? record["project"].toString() : ""}</td>
                <td className='tableword-wrap'>{record["createTime"].toString().substring(0, 10)}</td>
                <td className='tableword-wrap'>{record["status"] === 0 ? "Saved" : "Submitted"}</td>
                <td className='tableword-wrap'>
                <span onClick={(e)=>openRecordTab(record["id"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>View</u>
                </span>
                {(localStorage.getItem("role") === "0" || record["status"] === 0) && 
                <span> / </span>}
                {(localStorage.getItem("role") === "0" || record["status"] === 0) && 
                <span onClick={(e)=>editRecordTab(record["id"].toString(), record["status"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>Edit</u>
                </span>}
                {(record["status"] === 0) && 
                <span> / </span>}
                {(record["status"] === 0) && 
                <span onClick={(e)=>{setTempDeleteId(record["id"].toString()); setOpenConfirmDelete(true)}} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>Delete</u>
                </span>}
                    {/* <button onClick={(e)=>openRecordTab(record["contracT_NO"].toString())} style={{cursor:"pointer"}}>View</button> */}
                </td>
                <td className='tableword-wrap'>
                <span onClick={(e)=>cloneRecordTab(record["id"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>Clone</u>
                </span>
                </td>
                {(localStorage.getItem("role") === "0") && isDownload === true && 
                <td className='tableword-wrap'>
                <span onClick={(e)=>downloadRecord(record["id"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>Download</u>
                </span>
                </td>}
                {(localStorage.getItem("role") === "0") && 
                <td className='tableword-wrap'>
                <span onClick={(e)=>downloadList(record["id"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>Versions</u>
                </span>
                </td>}
                </tr></React.Fragment>
      })}
        {/* <tr className='bg-white' key="mdbtablerowexample1">
          <td>2</td>
          <td>Jacob</td>
          <td>Thornton</td>
          <td><MDBBadge color='success' pill>
              Awaiting
            </MDBBadge></td>
          <td>
          <MDBBtn onClick={(e)=>openRecordTab("0")} style={{cursor:"pointer"}} color='link' rounded size='sm'>
                    View
          </MDBBtn>
            </td>
        </tr>
        <tr className='table-success' key="mdbtablerowexample2">
          <td>3</td>
          <td>Larry the Bird</td>
          <td>@mdo</td>
          <td>@twitter</td>
          <td>
          <MDBBtn onClick={(e)=>openRecordTab("0")} style={{cursor:"pointer"}} color='link' rounded size='sm'>
                    View
          </MDBBtn>
            </td>
        </tr> */}
      {/* </tbody> */}
      
      </MDBTableBody>
    </MDBTable>

    {/*   <SimpleDialog
        open={openSuccessDelete}
        setOpen={setOpenSuccessDelete}
        messagetype="successdelete"
    /> */}
    <SimpleDialogSuccess openSuccess={openSuccessDelete} handleCloseSuccess={handleCloseSuccessDelete} messagetype='Successdelete'></SimpleDialogSuccess>
    

    <Dialog
            open={openConfirmDelete}
            onClose={()=>setOpenConfirmDelete(false)}
          >
                  
                  <Box
                  sx={{
                    width: "30rem",
                    maxWidth: { xs: "100%", sm: 600 },
                    borderRadius: 2,
                    padding: { xs: 3, sm: 4 },
                  }}>
                  <Typography
                      variant="h4"
                      sx={{
                        fontSize: { xs: "1.5rem", sm: "2rem" },
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        letterSpacing: { xs: 1, sm: 2 },
                        textAlign: "center",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                      }}
                    >
                      Confirm
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        mt: { xs: 1, sm: 2 },
                        fontWeight: 300,
                        opacity: 0.9,
                        textAlign: "center",
                        textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                      }}
                    >
                    Confirm Delete? This action would be irreversible.
                    </Typography>
                    <div className="mb-3"></div>
                    <Stack direction="row" spacing={2}>
                    <Button
                    variant="contained"
                    onClick={()=>{
                        handleDeleteSavedForm(tempDeleteId);
                    }}
                    fullWidth
                    sx={{
                      padding: { xs: "5px", sm: "6px" },
                      borderRadius: { xs: "20px", sm: "25px" },
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                        transform: "translateY(-2px)",
                        boxShadow: theme.shadows[4],
                      },
                      "&:focus": {
                        outline: `2px solid ${alpha(
                          theme.palette.primary.main,
                          0.5
                        )}`,
                        outlineOffset: "2px",
                      },
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    className='ml-3'
                    variant="contained"
                    onClick={()=>setOpenConfirmDelete(false)}
                    fullWidth
                    sx={{
                      padding: { xs: "50px", sm: "6px" },
                      borderRadius: { xs: "20px", sm: "25px" },
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                        transform: "translateY(-2px)",
                        boxShadow: theme.shadows[4],
                      },
                      "&:focus": {
                        outline: `2px solid ${alpha(
                          theme.palette.primary.main,
                          0.5
                        )}`,
                        outlineOffset: "2px",
                      },
                    }}
                  >
                    No
                  </Button>
                  </Stack>
                  </Box>
    
          </Dialog>



    <Dialog
        open={Open}
        onClose={handleClose}
      >
              
              <Box
              sx={{
                width: "30rem",
                maxWidth: { xs: "100%", sm: 400 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}>
              <Typography
                variant='h6'
                sx={{
                  fontWeight: 700,
                  color: theme.palette.primary.main,
                  letterSpacing: { xs: 1, sm: 2 },
                  textAlign: "center",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                }}
              >
                Versions
              </Typography>
              <MDBTable align='middle' className="table table-hover">
                <MDBTableHead>
                  <tr className='table-success' key="mdbtableheader">
                    <th>Version Number <br></br>版本號碼</th>
                    <th>Create Date And Time<br></br>建立日期和時間</th>
                  </tr>
                {/* </thead> */}
                </MDBTableHead>
                <MDBTableBody>
                {/* <tbody> */}
                {versionList === undefined || versionList === null ? <></>: versionList.sort((a, b) => (Number(a["versionNum"]) < Number(b["versionNum"])) ? 1 : -1).map((version, versionIndex)=>{
                    return <React.Fragment key={version["id"] + "&" + version["versionNum"]}>
                          <tr className={versionIndex % 2 === 1 ? 'table-success' : 'bg-white'} key={`mdbtablerow${versionIndex}`}>
                          <td>
                            <Typography
                              variant='body1'
                              sx={{
                                fontWeight: 700,
                                color: theme.palette.info.main,
                                letterSpacing: { xs: 1, sm: 2 },
                                textAlign: "center",
                                textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                              }}
                            >
                            <span onClick={(e)=>downloadPdfVersion(`${version["id"].toString()}&${version["versionNum"].toString()}`, version["downloadUrl"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                                <u>{"Version " + version["versionNum"]}</u>
                            </span>
                            </Typography>
                          </td>
                          <td>{ formatDate.formattedDate(new Date(version["createTime"]))}</td>
                          </tr></React.Fragment>
                })}
                
                </MDBTableBody>
              </MDBTable>
              {/* {versionList === undefined || versionList === null ? <></>: versionList.sort((a, b) => (Number(a["versionNum"]) < Number(b["versionNum"])) ? 1 : -1).map((version, versionIndex)=>{
              return <React.Fragment key={version["id"] + "&" + version["versionNum"]}>
              <Typography
                variant='body1'
                sx={{
                  fontWeight: 700,
                  color: theme.palette.info.main,
                  letterSpacing: { xs: 1, sm: 2 },
                  textAlign: "center",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                }}
              >
                <span onClick={(e)=>downloadPdfVersion(`${version["id"].toString()}&${version["versionNum"].toString()}`, version["downloadUrl"].toString())} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>{"Version " + version["versionNum"]}</u>
                </span>
              </Typography>
              </React.Fragment>})} */}
              </Box>

      </Dialog>


    {/* </Table> */}
    {<div style={{marginTop:"20px", textAlign:"right", width:"90%", display:"flex", flexDirection:"row", justifyContent:"right"}}>
        <div style={{marginRight:"30px"}}>
            <span style={{fontSize:"20px", verticalAlign:"middle"}}>{TotalRecord === 0? 0 : 1 + (pageNum -1)* pageSize}-{(TotalRecord/pageSize > pageNum)? (pageNum) * pageSize: TotalRecord} OF {TotalRecord}</span>
        </div>
        <button onClick={(e)=>{(1 < pageNum)? setPageNum(pageNum-1): setPageNum(pageNum)}} style={{width:"30px", height:"inherit", cursor:"pointer"}}>&lt;</button>
        <button onClick={(e)=>{(TotalRecord/pageSize > pageNum)? setPageNum(pageNum+1): setPageNum(pageNum)}} style={{width:"30px", marginRight:"10px", height:"inherit", cursor:"pointer"}}>&gt;</button>    
        <input
        style={{ width: '50px' }}
        type="number"
        onChange={handlePageChange}
        max={Math.ceil(TotalRecord/pageSize)}
        min="1"
        step="1" // Optional: Define the step for up/down arrows
        />
    </div>}
    </Container>
  );
}




export default FormList;